import { SVGProps } from 'react';

export const GridMode = (props: SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        preserveAspectRatio="xMinYMin meet"
        viewBox="0 0 48 48"
        {...props}
    >
        <path
            className="ico_pri"
            fillRule="evenodd"
            d="M11.5 13.87a.5.5 0 0 0-.5.5v5.4a.5.5 0 0 0 .5.5h8.31a.5.5 0 0 0 .5-.5v-5.4a.5.5 0 0 0-.5-.5H11.5Zm-2.5.5a2.5 2.5 0 0 1 2.5-2.5h8.31a2.5 2.5 0 0 1 2.5 2.5v5.4a2.5 2.5 0 0 1-2.5 2.5H11.5a2.5 2.5 0 0 1-2.5-2.5v-5.4Zm19.19-.5a.5.5 0 0 0-.5.5v5.4a.5.5 0 0 0 .5.5h8.31a.5.5 0 0 0 .5-.5v-5.4a.5.5 0 0 0-.5-.5h-8.31Zm-2.5.5a2.5 2.5 0 0 1 2.5-2.5h8.31a2.5 2.5 0 0 1 2.5 2.5v5.4a2.5 2.5 0 0 1-2.5 2.5h-8.31a2.5 2.5 0 0 1-2.5-2.5v-5.4ZM11.5 27.73a.5.5 0 0 0-.5.5v5.4a.5.5 0 0 0 .5.5h8.31a.5.5 0 0 0 .5-.5v-5.4a.5.5 0 0 0-.5-.5H11.5Zm-2.5.5a2.5 2.5 0 0 1 2.5-2.5h8.31a2.5 2.5 0 0 1 2.5 2.5v5.4a2.5 2.5 0 0 1-2.5 2.5H11.5a2.5 2.5 0 0 1-2.5-2.5v-5.4Zm19.19-.5a.5.5 0 0 0-.5.5v5.4a.5.5 0 0 0 .5.5h8.31a.5.5 0 0 0 .5-.5v-5.4a.5.5 0 0 0-.5-.5h-8.31Zm-2.5.5a2.5 2.5 0 0 1 2.5-2.5h8.31a2.5 2.5 0 0 1 2.5 2.5v5.4a2.5 2.5 0 0 1-2.5 2.5h-8.31a2.5 2.5 0 0 1-2.5-2.5v-5.4Z"
            clipRule="evenodd"
        />
    </svg>
);
